import type { PlayerProfileFormValue } from './types';

export const asString = (value: unknown): string => (typeof value === 'string' ? value : '');
export const asNumber = (value: unknown): string =>
  typeof value === 'number' && Number.isFinite(value) ? String(value) : '';

export const setString = (
  current: PlayerProfileFormValue,
  key: string,
  raw: string,
  onChange: (next: PlayerProfileFormValue) => void,
) => {
  const next = { ...current };
  if (!raw.trim()) {
    delete next[key];
  } else {
    next[key] = raw;
  }
  onChange(next);
};

export const setNumber = (
  current: PlayerProfileFormValue,
  key: string,
  raw: string,
  onChange: (next: PlayerProfileFormValue) => void,
) => {
  const next = { ...current };
  if (!raw.trim()) {
    delete next[key];
    onChange(next);
    return;
  }
  const parsed = Number(raw);
  if (Number.isFinite(parsed)) {
    next[key] = parsed;
    onChange(next);
  }
};
